/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FacilityGroupNotificationSetting } from '../../models/facility-group-notification-setting';
import { FacilityGroupNotificationSettingDto } from '../../models/facility-group-notification-setting-dto';

export interface AddSetting_1$Params {
      body: FacilityGroupNotificationSettingDto
}

export function addSetting_1(http: HttpClient, rootUrl: string, params: AddSetting_1$Params, context?: HttpContext): Observable<StrictHttpResponse<FacilityGroupNotificationSetting>> {
  const rb = new RequestBuilder(rootUrl, addSetting_1.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FacilityGroupNotificationSetting>;
    })
  );
}

addSetting_1.PATH = '/api/facilityGroup/notification/setting';
